import { z } from 'zod';

/**
 * Who may write a custom attribute or event (BB-33, DAT-007): `any`; `server_only_report` accepts client writes but
 * reports them (rollout step); `server_only` refuses them.
 */
export const WritePolicy = z.enum(['any', 'server_only_report', 'server_only']);
export type WritePolicy = z.infer<typeof WritePolicy>;

/** Minimum length of the reason for loosening a write policy (e.g. `server_only` → `any`). */
export const WRITE_POLICY_REASON_MIN = 10;

export const TrustReportQuery = z.object({ days: z.coerce.number().int().min(1).max(90).default(7) });
export type TrustReportQuery = z.infer<typeof TrustReportQuery>;
